import React from 'react';
import { cx } from '../ds/classes';

// Building blocks for the marketing and account pages, so they share one width, rhythm and type scale

/** The page's content column */
export const Container = ({ className, children }) => (
  <div className={cx('w-full max-w-[1200px] mx-auto px-space-4 sm:px-space-6', className)}>{children}</div>
);

/** A page: base ground, generous vertical rhythm */
export const Page = ({ children, className }) => (
  <main className={cx('flex-1 bg-base text-ink font-text', className)}>{children}</main>
);

/** A page title with an optional short label above it and a lead paragraph */
export const PageHeader = ({ eyebrow, title, lead, children }) => (
  <header className="flex flex-col gap-space-4 max-w-[760px]">
    {eyebrow && <span className="text-label text-muted">{eyebrow}</span>}
    <h1 className="m-0 font-display font-extrabold text-[44px] leading-[1] tracking-[-0.03em] sm:text-[60px] text-ink">{title}</h1>
    {lead && <p className="m-0 text-[19px] leading-[1.5] text-ink-soft">{lead}</p>}
    {children}
  </header>
);

/** A section heading with an optional line under it */
export const SectionHeading = ({ id, title, lead }) => (
  <div className="flex flex-col gap-space-2 max-w-[680px]">
    <h2 id={id} className="m-0 font-display text-title-2 text-ink">{title}</h2>
    {lead && <p className="m-0 text-lead text-ink-soft">{lead}</p>}
  </div>
);

/** A surface card */
export const Card = ({ className, children }) => (
  <div className={cx('flex flex-col gap-space-3 p-space-6 rounded-radius-lg bg-surface', className)}>{children}</div>
);

/** Numbered steps, each a number, a title and one line */
export const Steps = ({ steps, labelledBy }) => (
  <ol aria-labelledby={labelledBy} className="m-0 p-0 list-none grid gap-space-4 sm:grid-cols-2 lg:grid-cols-4">
    {steps.map((step, index) => (
      <li key={step.title} className="flex flex-col gap-space-2 pt-space-4 border-t-2 border-line">
        <span className="font-mono text-data-sm text-muted" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
        <span className="font-display text-section text-ink">{step.title}</span>
        <span className="text-body text-ink-soft">{step.text}</span>
      </li>
    ))}
  </ol>
);
